import {
  ResponseTypeForGamesByRound,
  ValidationResponseCodeForGameByRound,
  ValidationType,
} from '../constants/validationType';
import { DefaultQueryParams } from '../constants/defaultQueryParams';
import { parseQuery } from './parseQuery';
import { ROUND_GAMES_GAME_IDS } from '../constants/gameIds';

export function isResponseNotEnoughBalance(code) {
  const { [DefaultQueryParams.GameId]: gameId } = parseQuery(window.location.search);
  return (
    code === ValidationType.NotEnoughMoney ||
    (code === ValidationResponseCodeForGameByRound[ResponseTypeForGamesByRound.NotEnoughBalance] &&
      ROUND_GAMES_GAME_IDS.includes(+gameId)) ||
    code === ValidationType.InsufficientBalance
  );
}
